var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.67 11H6.19a.42.42 0 0 1-.43-.42v-3s-.09-.14-.23-.14H4.05c-.14 0-.23.09-.23.14v3a.43.43 0 0 1-.43.42H1a1 1 0 0 1-1-1V4.53a.3.3 0 0 1 0-.15.5.5 0 0 1 .1-.14L4.51.12a.45.45 0 0 1 .6 0l4.38 4a.5.5 0 0 1 .1.13.6.6 0 0 1 0 .14L9.67 10a1 1 0 0 1-1 1M4.05 6.57h1.48a1 1 0 0 1 1.09 1v2.63h2.05a.14.14 0 0 0 .14-.2V4.53L4.82 1 .86 4.7V10a.15.15 0 0 0 .15.14H3v-2.6a1 1 0 0 1 1.05-.97"
  })));
};
export default SvgHome;